import styled from "styled-components";


export const PageCamerasContainer = styled.section`
  margin: 0 10px 0 10px;
  
`

export const PageCamerasArticle = styled.article`
    display: flex;
  flex-direction: column;
  padding: 20px;
  cursor: pointer;
  border: 1px solid black;
  border-radius: 15px;
  &:hover {
    background: rgba(246, 238, 229, 0.5);
  }
  

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }
    cursor: none;
  }
`

export const PageCamerasText = styled.p`
    margin: 0;
  padding: 0;
  align-self: center;
`

